export enum ChangeOrderStatusEnum {
  APPROVE = 'Approve',
  REJECT = 'Reject',
  PENDING_IN_REVIEW = 'Pending - In Review',
}
